export default "__VITE_ASSET__CnwpEfFq__"